import { all, AllEffect, call, fork, put, takeLatest } from '@redux-saga/core/effects';
import { Effect } from 'redux-saga/effects';
import axios from 'axios';

import {
  POST_VISITOR_REGISTER_REQUEST,
  POST_VISITOR_REGISTER_SUCCESS,
  POST_VISITOR_REGISTER_FAILURE,
  COMMON_FAILURE,
  GET_VISITOR_RESERVATION_CHECK_SUCCESS,
  GET_VISITOR_RESERVATION_CHECK_FAILURE,
  GET_VISITOR_RESERVATION_CHECK_REQUEST,
} from '../../actions';
import visitorRegisterService from '../../services/visitorRegisterService';

function* postVisitorRegister(action: any): Generator<unknown> {
  try {
    const res: any = yield call(visitorRegisterService(action).postVisitorRegister);
    if (res && res.status === 200) {
      yield put({
        type: POST_VISITOR_REGISTER_SUCCESS,
        res: res.data,
      });
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: POST_VISITOR_REGISTER_FAILURE,
        error: { message: 'エラーが発生しました' },
      });
      yield put({
        type: COMMON_FAILURE,
        error: error.response?.data,
      });
      if (error.response && error.response.status >= 400) {
        action.history.push('/system-error');
      }
    }
  }
}

function* watchPostVisitorRegister() {
  yield takeLatest(POST_VISITOR_REGISTER_REQUEST, postVisitorRegister);
}

function* getVisitorBlackListCheck(action: any): Generator<unknown> {
  try {
    const res: any = yield call(visitorRegisterService(action).getVisitorBlackListCheck);
    if (res && res.status === 200) {
      yield put({
        type: GET_VISITOR_RESERVATION_CHECK_SUCCESS,
        res: res.data,
      });
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: GET_VISITOR_RESERVATION_CHECK_FAILURE,
        error: { message: 'エラーが発生しました' },
      });
      yield put({
        type: COMMON_FAILURE,
        error: error.response?.data,
      });
      if (error.response && error.response.status >= 400) {
        action.history.push('/system-error');
      }
    }
  }
}

function* watchGetVisitorReservationCheck() {
  yield takeLatest(GET_VISITOR_RESERVATION_CHECK_REQUEST, getVisitorBlackListCheck);
}

export default function* visitorRegisterSaga(): Generator<AllEffect<Effect>> {
  yield all([fork(watchPostVisitorRegister), fork(watchGetVisitorReservationCheck)]);
}
